var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13699_69346)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13699_69346",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 96,
    height: 96
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13699_69346)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.8 70C66.4667 70 67.8833 69.4167 69.05 68.25C70.2167 67.0833 70.8 65.6667 70.8 64C70.8 62.3333 70.2167 60.9167 69.05 59.75C67.8833 58.5833 66.4667 58 64.8 58C63.1333 58 61.7167 58.5833 60.55 59.75C59.3833 60.9167 58.8 62.3333 58.8 64C58.8 65.6667 59.3833 67.0833 60.55 68.25C61.7167 69.4167 63.1333 70 64.8 70ZM64.8 82C66.8 82 68.6667 81.5333 70.4 80.6C72.1333 79.6667 73.5667 78.3667 74.7 76.7C73.1667 75.7667 71.5667 75.0833 69.9 74.65C68.2333 74.2167 66.5333 74 64.8 74C63.0667 74 61.3667 74.2167 59.7 74.65C58.0333 75.0833 56.4333 75.7667 54.9 76.7C56.0333 78.3667 57.4667 79.6667 59.2 80.6C60.9333 81.5333 62.8 82 64.8 82ZM30.8 37.2H54.8V29.2C54.8 25.8667 53.6333 23.0333 51.3 20.7C48.9667 18.3667 46.1333 17.2 42.8 17.2C39.4667 17.2 36.6333 18.3667 34.3 20.7C31.9667 23.0333 30.8 25.8667 30.8 29.2V37.2ZM46 82.8H22C20.2667 82.8 18.8333 82.2333 17.7 81.1C16.5667 79.9667 16 78.5333 16 76.8V43.2C16 41.4667 16.5667 40.0333 17.7 38.9C18.8333 37.7667 20.2667 37.2 22 37.2H28V29.2C28 25.0667 29.4333 21.5667 32.3 18.7C35.1667 15.8333 38.6667 14.4 42.8 14.4C46.9333 14.4 50.4333 15.8333 53.3 18.7C56.1667 21.5667 57.6 25.0667 57.6 29.2V37.2H63.6C65.3333 37.2 66.7667 37.7667 67.9 38.9C69.0333 40.0333 69.6 41.4667 69.6 43.2V47.8C69.2667 47.6667 68.85 47.5667 68.35 47.5C67.85 47.4333 67.3333 47.4 66.8 47.4V43.2C66.8 42.2667 66.5 41.5 65.9 40.9C65.3 40.3 64.5333 40 63.6 40H22C21.0667 40 20.3 40.3 19.7 40.9C19.1 41.5 18.8 42.2667 18.8 43.2V76.8C18.8 77.7333 19.1 78.5 19.7 79.1C20.3 79.7 21.0667 80 22 80H44.4C44.5333 80.5333 44.7333 81.0333 45 81.5C45.2667 81.9667 45.6 82.4 46 82.8ZM64.8 84.8C60.6667 84.8 57.1667 83.3667 54.3 80.5C51.4333 77.6333 50 74.1333 50 70C50 65.8667 51.4333 62.3667 54.3 59.5C57.1667 56.6333 60.6667 55.2 64.8 55.2C68.9333 55.2 72.4333 56.6333 75.3 59.5C78.1667 62.3667 79.6 65.8667 79.6 70C79.6 74.1333 78.1667 77.6333 75.3 80.5C72.4333 83.3667 68.9333 84.8 64.8 84.8Z",
    fill: "#00B0CA"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13699_69346",
    x: 12,
    y: 14.4,
    width: 71.6,
    height: 78.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13699_69346"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13699_69346",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockPerson);
export default __webpack_public_path__ + "static/media/LockPerson.65663423dbce55cda80bf4c99aa79255.svg";
export { ForwardRef as ReactComponent };